import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Paintbrush, Hammer, Ruler, Lightbulb, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SEOHead } from "@/components/SEOHead";

const services = [
    {
        id: "komple-tadilat",
        icon: Hammer,
        titleKey: "services.renovation.complete.title",
        descKey: "services.renovation.complete.desc",
        color: "text-blue-500",
        bg: "bg-blue-50"
    },
    {
        id: "boya-badana",
        icon: Paintbrush,
        titleKey: "services.renovation.painting.title",
        descKey: "services.renovation.painting.desc",
        color: "text-green-500",
        bg: "bg-green-50"
    },
    {
        id: "ic-mimari",
        icon: Ruler,
        titleKey: "services.renovation.interior.title",
        descKey: "services.renovation.interior.desc",
        color: "text-purple-500",
        bg: "bg-purple-50"
    },
    {
        id: "dekorasyon",
        icon: Lightbulb,
        titleKey: "services.renovation.decoration.title",
        descKey: "services.renovation.decoration.desc",
        color: "text-orange-500",
        bg: "bg-orange-50"
    }
];

const TadilatDekorasyon = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <>
            <SEOHead />
            <div className="min-h-screen bg-background py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-16">
                        <h1 className="text-4xl font-bold mb-4 text-foreground">
                            {t('services.renovation.title')}
                        </h1>
                        <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
                            {t('services.renovation.subtitle')}
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-8">
                        {services.map((service) => (
                            <Card key={service.id} className="hover:shadow-lg transition-shadow duration-300">
                                <CardHeader className="flex flex-row items-center gap-4">
                                    <div className={`p-3 rounded-xl ${service.bg}`}>
                                        <service.icon className={`w-8 h-8 ${service.color}`} />
                                    </div>
                                    <CardTitle className="text-xl">{t(service.titleKey)}</CardTitle>
                                </CardHeader>
                                <CardContent>
                                    <p className="text-muted-foreground mb-6">
                                        {t(service.descKey)}
                                    </p>
                                    <Button
                                        variant="outline"
                                        className="w-full group"
                                        onClick={() => navigate(`/tadilat-dekorasyon/${service.id}`)}
                                    >
                                        {t('common.details')}
                                        <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                                    </Button>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default TadilatDekorasyon;
